export default {"src":"/_next/static/media/years_logo_gold.a42c7a11.svg","height":138,"width":311,"blurWidth":0,"blurHeight":0};